var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { SvgIcon } from "@material-ui/core";
const SvgExpand = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-946 -1767)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.918-3.914a.469.469,0,0,0,.664,0l5.781-5.734a.469.469,0,0,0,0-.664l-.773-.773a.469.469,0,0,0-.664,0L6.25-6.457,1.574-11.086a.469.469,0,0,0-.664,0l-.773.773a.469.469,0,0,0,0,.664Z",
  transform: "translate(950.138 1786)"
}))));
export default SvgExpand;